export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13251.84e55c12.jpg";